export const PM_CONFERENCES_PATH = "/conferences";
export const BILLING_LEDGER_ENTRIES_PATH = "/billing-ledger-entries";
export const BILLING_REPORTINGS_PATH = "/billing-reportings";
export const EVENT_BILLING_PATH = "/billing-events";
export const DOCUMENT_SENDING_ENTRIES = "/document-sending-entries";
export const BILLING_EVN_CAPS = "/billing-evn-caps";
export const WEBCAST = "/webcast";
export const PROJECTMAIL = "/projectmail";
